import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../../components/footer/Footer";
import CopyRight from "../../../components/footer/CopyRight";
import FancyFeatureTewentyTwo from "../../../components/features/FancyFeatureTewentyTwo";
import Smart from "../../../assets/images/assets/Smart Contract Development.png";
import Dapp from "../../../assets/images/assets/DApp Development.png";
import Chain from "../../../assets/images/assets/blockchain Integration.png";
import NFT from "../../../assets/images/assets/NFT Platforms & Marketplaces.png";
import Contract from "../../../assets/images/assets/Custom Tokenomics Design.png";

import FancyFeatureTen from "../../../components/features/FancyFeatureTen";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponentProduct from "../../../assets/Sub-component/CoreComponentProduct";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import CoreComponentProduct2 from "../../../assets/Sub-component/CoreComponentProduct2";
import Corenew from "../../../components/features/Corenew";
import { Link } from "react-router-dom";


import Behavioral_Biometrics from '../../../assets/Services/Virtual_vegas/Engineering_virtual/Behavioral_Biometrics.svg'
import Chatbot_Customer_Support from '../../../assets/Services/Virtual_vegas/Engineering_virtual/Chatbot_Customer_Support.svg'
import Cross from '../../../assets/Services/Virtual_vegas/Engineering_virtual/Cross-platform_Compatibility.svg'
import Dynamic_Game_Adaptation from '../../../assets/Services/Virtual_vegas/Engineering_virtual/Dynamic_Game_Adaptation.svg'
import Predictive_Analysis from '../../../assets/Services/Virtual_vegas/Engineering_virtual/Predictive_Analysis.svg'
import Real from '../../../assets/Services/Virtual_vegas/Engineering_virtual/Real-time_Multiplayer_Games.svg'
import Scalable_Server_Infrastructure from '../../../assets/Services/Virtual_vegas/Engineering_virtual/Scalable_Server_Infrastructure.svg'
import Social_Features_and_Interactions from '../../../assets/Services/Virtual_vegas/Engineering_virtual/Social_Features_and_Interactions.svg'

import Ancient_Egypt from '../../../assets/Services/Virtual_vegas/Environment_themes/Ancient_Egypt.svg'
import Futuristic_Cityscape from '../../../assets/Services/Virtual_vegas/Environment_themes/Futuristic_Cityscape.svg'
import Medieval_Castle from '../../../assets/Services/Virtual_vegas/Environment_themes/Medieval_Castle.svg'
import Space_Odyssey from '../../../assets/Services/Virtual_vegas/Environment_themes/Space_Odyssey.svg'
import Tropical_Paradise from '../../../assets/Services/Virtual_vegas/Environment_themes/Tropical_Paradise.svg'
import Wild_West_Saloon from '../../../assets/Services/Virtual_vegas/Environment_themes/Wild_West_Saloon.svg'

import Advanced_Multiplayer from '../../../assets/Services/Virtual_vegas/Keyfeatures/Advanced_Multiplayer.svg'
import Advanced_Security from '../../../assets/Services/Virtual_vegas/Keyfeatures/Advanced_Security.svg'
import Customisable_Branding from '../../../assets/Services/Virtual_vegas/Keyfeatures/Customisable_Branding.svg'
import Seamless_Integration from '../../../assets/Services/Virtual_vegas/Keyfeatures/Seamless_Integration.svg'
import launchingimage from '../../../assets/Launchingimage.png'
const VirutalVegas = () => {
  const [technical, setTechnical] = useState(true);
  const [innovaton, setinnovaton] = useState(false);
  const [Reports, setReports] = useState(false);

  const handleclick = () => {
    setTechnical(true);
    setReports(false);
    setinnovaton(false);
  };
  const handleclick2 = () => {
    setTechnical(false);
    setReports(true);
    setinnovaton(false);
  };
  const handleclick3 = () => {
    setTechnical(false);
    setReports(false);
    setinnovaton(true);
  };

  const FeaturesContent = [
    {
      bgColor: "#BCFFCB",
      icon: Tropical_Paradise,
      title: "Tropical Paradise",
      desc: `Experience virtual paradise with a naturalistic view among the palm tree breeze, crystal clear water, and vibrant cocktails to completely indulge in the beach view bar.`,
      dataDealy: "0",
    },
    {
      bgColor: "#E0F8F8",
      icon: Ancient_Egypt,
      title: "Ancient Egypt",
      desc: `An archaeological adventure with a chronological view of pyramids, mysterious hieroglyphics adorn the walls of ancient temples.`,
      dataDealy: "100",
    },
    {
      bgColor: "#F7EDFF",
      icon: Futuristic_Cityscape,
      title: "Futuristic Cityscape",
      desc: `Neon lights, flying zip cars, enormous skyscrapers, and cutting-edge technology are features that draw attention to a busy metropolis.`,
      dataDealy: "200",
    },
    {
      bgColor: "#FFEBDB",
      icon: Medieval_Castle,
      title: "Medieval Castle",
      desc: `Opens the door of the medieval castle, viewing the towering turrets, stone walls, and a grand banquet hall, delivering the symbol of royalty.     
`,
      dataDealy: "0",
    },
    {
      bgColor: "#FFEBDB",
      icon: Space_Odyssey,
      title: " Space Odyssey ",
      desc: `  Travel through outer space and view the galaxies, cosmic space, planets, and so on, as if you were an alien viewing them all.   
`,
      dataDealy: "0",
    },
    {
      bgColor: "#FFEBDB",
      icon: Wild_West_Saloon,
      title: "  Wild West Saloon",
      desc: `   Saddle your ride through the nostalgic Wild West era, heading to the local saloon to gaze at playing card games, whiskey shots, and cowboy hats.`,
      dataDealy: "0",
    },
  ];

  const FeatureContent = [
    {
      icon: Customisable_Branding,
      title: "Customizable Branding",
      subTitle: `Delivers customized logos, themes, and design layouts to provide a casino experience that’s unique for players.`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Advanced_Multiplayer,
      title: "Advanced Multiplayer",
      subTitle: `Get along with multiplayer and make an intense rivalry involving actual battles with your team connecting across the world.`,
      bgColor: "#6D49FF",
    },
    {
      icon: Seamless_Integration,
      title: "Seamless Integration",
      subTitle: `VirtualVegas is easy to integrate into any platform, quick, seamless, and compatible with all devices.`,
      bgColor: "#FFB951",
    },
    {
      icon: Advanced_Security,
      title: "Advanced Security",
      subTitle: `Protecting the player data with strong encryption. VirtualVegas ensures security so you can focus on delivering great gameplay.`,
      bgColor: "#FF4A8B",
    },
  ];

  const feature = [
    {
      icon: Real,
      title: "Real-time Multiplayer Games  ",
      desc: "Interact with fellow participants in real-time multiplayer settings. These interactions hang around contests and a shared enthusiasm for the activity and community.  ",
    },
    {
      icon: Cross,
      title: "Cross-platform Compatibility ",
      desc: " Engage in global multiplayer, which increases excitement and facilitates game connectivity on PCs and mobile devices. ",
    },
    {
      icon: Scalable_Server_Infrastructure,
      title: " Scalable Server Infrastructure ",
      desc: "  Regardless of peak times, any number of players can connect and automatically receive support from the cloud services for seamless gameplay.",
    },

    {
      icon: Social_Features_and_Interactions,
      title: " Social Features and Interactions",
      desc: " Assemble your crew, join groups, and celebrate your successes. Remain engaged and connected with seamless social gameplay. ",
    },
  ];

  const feature2 = [
    {
      icon:Predictive_Analysis ,
      title: " Predictive Analysis ",
      desc: " Engaging the player's interest with AI-powered insights provides tailored game recommendations and deals.  ",
    },
    {
      icon: Dynamic_Game_Adaptation,
      title: "Dynamic Game Adaptation  ",
      desc: " The gameplay adapts in real time to the skill and preferences of each player.  ",
    },
    {
      icon:Behavioral_Biometrics ,
      title: " Behavioral Biometrics ",
      desc: "   AI monitors distinct player behaviors to easily detect fraud and confirm identity.",
    },
    {
      icon:Chatbot_Customer_Support ,
      title: "Chatbot Customer Support  ",
      desc: " AI chatbots offer 24/7 assistance by responding to queries and resolving problems in real time through open conversations.  ",
    },
  ];

  return (
    <>
   <img 
          src={launchingimage} 
          className="Bg-image z-0"
          alt="Launching"
        />
    
    <div className=" overflow-hidden ">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div className="bg-white">
        <div
          className=" container   d-flex align-items-center justify-content-center flex-column "
          style={{ minHeight: "100vh",position:'relative' }}
        >
          <h1 className="h1-heading fw-bold text-center">Virtual Vegas</h1>
          <p className="mt-3 h1-para lh-base">
            {" "}
            Blockchain encircles the casino, powering the entertainment within a
            highly secure Raiden Network environment.
          </p>
          <Link to="/request-quote">
            {" "}
            <button
              className="h3-para btn btn-primary mt-3 py-3 px-3 btn-gradient border-0  rounded-4"
              style={{ fontSize: 18 }}
            >
              {" "}
              Get Your Free Quote{" "}
            </button>{" "}
          </Link>
        </div>
      </div>

      <div className="fancy-feature-twentyTwo mt-80 mart ">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-8 m-auto">
              <div className=" text-center ">
                <h2 className="h2-heading mb-md-3 mb-2 pb-2 fw-bold">
                  Key Features
                </h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <CoreComponentProduct2 FeatureContent={FeatureContent} />
          </div>
        </div>
      </div>

      <div className="fancy-feature-twentyTwo mt-80 mart ">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-8 m-auto">
              <div className=" text-center ">
                <h2 className="h2-heading mb-3 fw-bold">
                  Choice of Environments and Themes
                </h2>
              </div>
            </div>
          </div>
          <Corenew FeaturesContent={FeaturesContent} />
        </div>
      </div>

      <div className="container mt-80 mart">
        <h2 className="h2-heading pb-3 text-center">
          Engineered for Virtual Vegas{" "}
        </h2>
        <div>
          <div className="d-flex justify-content-evenly mt-3 pt-lg-2">
            <h3
              className={`h3-heading cursor ${
                technical ? "text-underline-gradient fw-semibold " : "fw-less"
              } `}
              onClick={handleclick}
            >
              Multiplayer Networking
            </h3>
            {/* 
            <h3
              className={`h3-heading cursor ${
                innovaton ? "text-underline-gradient fw-semibold " : "fw-less"
              } `}
              onClick={handleclick3}
            >
              Technical Innovations
            </h3> */}

            <h3
              className={`h3-heading cursor  ${
                Reports ? "text-underline-gradient fw-semibold " : "fw-less"
              } `}
              onClick={handleclick2}
            >
              AI Integration
            </h3>
          </div>
          <CoreComponentProduct
            technical={technical}
            feature={feature}
            feature2={feature2}
          />
        </div>
      </div>

      <footer className="theme-footer-two pt-80 padt ">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default VirutalVegas;
